
import { mapGetters } from 'vuex'

export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('global', ['footerSettings']),
  },
}
